import { render, staticRenderFns } from "./CalculatorLight.vue?vue&type=template&id=1a7680f8&scoped=true"
import script from "./CalculatorLight.vue?vue&type=script&lang=ts"
export * from "./CalculatorLight.vue?vue&type=script&lang=ts"
import style0 from "./CalculatorLight.vue?vue&type=style&index=0&id=1a7680f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7680f8",
  null
  
)

export default component.exports